"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CalculationDialog = void 0;
const tslib_1 = require("tslib");
const catalog_core_1 = require("@tableau/catalog-core");
const catalog_messages_1 = require("@tableau/catalog-messages");
const widgets_1 = require("@tableau/widgets");
const react_1 = tslib_1.__importDefault(require("react"));
const SvgFieldIcon_1 = require("../field/components/SvgFieldIcon");
const FieldFunctions_1 = require("../field/functions/FieldFunctions");
const FieldNameMapping_1 = require("../field/functions/FieldNameMapping");
const TableauExpressionFormatter_1 = require("../tableauExpression/components/TableauExpressionFormatter");
const VizClientFieldCardStyles_1 = require("./VizClientFieldCardStyles");
function CalculationDialog(props) {
    const [hasBeenCopied, setCopiedState] = react_1.default.useState(false);
    const fieldIcon = (0, FieldFunctions_1.iconForField)(props.field);
    const siteUrls = (0, catalog_core_1.useSiteUrls)();
    const copyToClipboard = e => {
        const temporaryTextArea = document.createElement('textarea');
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        temporaryTextArea.innerText = props.field.formula;
        document.body.appendChild(temporaryTextArea);
        temporaryTextArea.select();
        // eslint-disable-next-line deprecation/deprecation
        document.execCommand('copy');
        setCopiedState(true);
        temporaryTextArea.remove();
        // refocus the copy button so focus doesn't fall on body
        e.currentTarget.focus();
        setTimeout(() => {
            setCopiedState(false);
        }, VizClientFieldCardStyles_1.calculationDialogCopiedTextAnimationDuration);
    };
    return props.isOpen
        ? (react_1.default.createElement(widgets_1.DialogWidget, { testId: 'Calcluation-Lightbox-Dialog', title: catalog_messages_1.Messages.DataDetailsCalculation(), type: widgets_1.DialogType.NormalWithTitleBar, positioningBehavior: widgets_1.DialogPositioningBehavior.Centered, dialogWidth: 500, showCloseButton: true, showFooter: false, isModal: true, onCloseRequest: props.onClose, handleGlassClick: props.onClose, shouldReturnFocusOnClose: true },
            react_1.default.createElement(VizClientFieldCardStyles_1.CalculationDialogHeader, null, props.field.name),
            react_1.default.createElement(VizClientFieldCardStyles_1.CalculationDialogTypeInfo, null,
                react_1.default.createElement(SvgFieldIcon_1.SvgFieldIcon, { fieldIcon: fieldIcon }),
                react_1.default.createElement("span", null, fieldIcon ? FieldNameMapping_1.FieldNameMappings[fieldIcon]() : '')),
            react_1.default.createElement(VizClientFieldCardStyles_1.CalulationDialogTextBoxLabel, null, catalog_messages_1.Messages.DataDetailsCalculation()),
            react_1.default.createElement(VizClientFieldCardStyles_1.CalculationDialogTextBox, null,
                react_1.default.createElement(TableauExpressionFormatter_1.TableauExpressionFormatter
                // The code was like this before the lint rule was enabled
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                , { 
                    // The code was like this before the lint rule was enabled
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    expression: props.field.formula, fields: props.field.fields, parameters: props.field.parameters, makeFieldUrl: (fieldId) => props.workbookVizportalUrlId
                        ? siteUrls.workbookLineageFieldUrl(props.workbookVizportalUrlId, fieldId)
                        : '', openLinksInNewTab: true })),
            react_1.default.createElement(VizClientFieldCardStyles_1.CalculationDialogFooter, null,
                hasBeenCopied && (react_1.default.createElement(VizClientFieldCardStyles_1.CalculationDialogCopiedText, { role: 'alert' }, catalog_messages_1.Messages.DataDetailsCalculationCopiedToClipboard())),
                react_1.default.createElement(widgets_1.ButtonWidget, { buttonType: widgets_1.ButtonType.Primary, testId: 'Calculation-Dialog-Copy', onClick: copyToClipboard }, catalog_messages_1.Messages.DialogCopy()))))
        : null;
}
exports.CalculationDialog = CalculationDialog;
//# sourceMappingURL=CalculationDialog.js.map